import PaidIcon from "@mui/icons-material/Paid";
import SendIcon from "@mui/icons-material/Send";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { checkByProfileGuard } from "../../../../shared/guards/ProfileGuard";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../../shared/enums/profiles";
import { useProfile } from "../../../../context/ProfileContext";
import { deriveLivveUiStatus, LivveInvoiceRow } from "../../../../shared/services/api/comission/ComissionServices";

export type LivveMenuModalType = "details" | "send" | "confirmPayment";

interface LivveMenuProps {
	anchorEl: null | HTMLElement;
	open: boolean;
	onClose: () => void;
	selectedRow: LivveInvoiceRow | null;
	onOpenModal: (type: LivveMenuModalType, row: LivveInvoiceRow) => void;
}

export const LivveMenu = ({ anchorEl, open, onClose, selectedRow, onOpenModal }: LivveMenuProps) => {
	const { isSuperAdmin } = useProfile();
	// Ações granulares Livve — pedido formalizado pro backend, ver GAPS_LIVVE_V2_PARA_BACKEND.md.
	const canSend = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.LivveSend);
	const canConfirmPayment = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.LivveConfirmPayment);
	if (!selectedRow) return null;

	const uiStatus = deriveLivveUiStatus(selectedRow);

	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("details", selectedRow);
				}}
			>
				<ListItemIcon>
					<VisibilityIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Visualizar detalhes" />
			</MenuItem>

			{uiStatus === "ready" && <Divider />}
			{uiStatus === "ready" && (
				<MenuItem
					onClick={() => {
						onClose();
						onOpenModal("send", selectedRow);
					}}
					disabled={!canSend}
				>
					<ListItemIcon>
						<SendIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Enviar pra Livve" />
				</MenuItem>
			)}

			{uiStatus === "sent" && <Divider />}
			{uiStatus === "sent" && (
				<MenuItem
					onClick={() => {
						onClose();
						onOpenModal("confirmPayment", selectedRow);
					}}
					disabled={!canConfirmPayment}
				>
					<ListItemIcon>
						<PaidIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Confirmar pagamento" />
				</MenuItem>
			)}
		</Menu>
	);
};
